module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_7005.c8f1eb7c.png";